$(document).ready(function() {

  /* napoveda */
  $('#help').on("click", function() {
    $( "#helper" ).fadeIn( "slow", function() {
    });
    var helpBox = document.getElementById("helpBox");
    TweenMax.to(helpBox, 1, {x:0, y:849,  ease:Quint.easeOut});
    TweenMax.to(helpBox, 0.5, {autoAlpha:1});
  });
  $('#helpClose').on("click", function() {
    var helpBox = document.getElementById("helpBox");
    TweenMax.to(helpBox, 1, {x:0, y:0,  ease:Quint.easeOut});
    TweenMax.to(helpBox, 0.5, {autoAlpha:1});
    $( "#helper" ).fadeOut( "slow", function() {
    });
  });
  $('#helper').on("click", function() {
    var helpBox = document.getElementById("helpBox");
    TweenMax.to(helpBox, 1, {x:0, y:0,  ease:Quint.easeOut});
    TweenMax.to(helpBox, 0.5, {autoAlpha:1});
    $( "#helper" ).fadeOut( "slow", function() {
    });
  });

  start_menu();
});
